import { Component, Input, OnInit } from '@angular/core';
import { CdkStepper } from '@angular/cdk/stepper';
import { NgClass, NgTemplateOutlet } from '@angular/common';

@Component({
  selector: 'cap-wizard',
  templateUrl: './capi-wizard.component.html',
  styleUrls: ['./capi-wizard.component.scss'],
  providers: [{ provide: CdkStepper, useExisting: CapiWizardComponent }],
  imports: [NgClass, NgTemplateOutlet]
})
export class CapiWizardComponent extends CdkStepper implements OnInit {
  @Input() readonly = false;

  ngOnInit() {
    if (this.readonly) {
      this.linear = false;
    }
  }

  selectStepByIndex(index: number): void {
    const canSelectIndex = this.readonly || this.steps.get(index).completed;
    if (canSelectIndex) {
      this.selectedIndex = index;
    }
  }
}
